import React from "react";

import Heading from "@busbud/design-system-components/dist/Heading";
import Stack from "@busbud/design-system-components/dist/Stack";
import Text from "@busbud/design-system-components/dist/Text";

import { GreyedBubblesIllustration } from "./greyed-bubbles-illustration";

export const NoActivity: React.FC = () => {
  return (
    <Stack direction="column" spacing={1} alignItems="center">
      <GreyedBubblesIllustration />
      <Heading size="md" color="text.secondary.opaque">
        No activity here.
      </Heading>
      <Text size="md" color="text.secondary.opaque">
        There are no transactions to show for this year.
      </Text>
    </Stack>
  );
};
